import { textDecoration } from '@chakra-ui/system';
import config from '@config';
import merge from 'lodash/merge';

const fontFamily = 'FedraSansStd-medium';

const commonLangStyle = ({ lang, ...props }) => {
  const isIndian = config.indianLang.indexOf(lang) > -1;
  const styleObj = {
    titleText: {
      fontSize: { base: '32px', md: '48px' },
      fontFamily: isIndian ? config.momLangFont[lang] : 'Trirong',
      fontWeight: 500,
      color: '#FFFFFF',
      lineHeight: { base: '28.8px', md: '38.4px' },
    },
    titleSubtext: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Trirong',
      fontStyle: 'italic',
      fontWeight: 500,
      fontSize: { base: '40px', md: '48px' },
      lineHeight: { base: '36px', md: '43.2px' },
      color: '#EC1C2D',
    },

    additionalTextLine: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Trirong',
      color: '#FFFFFF',
      fontWeight: 400,
      fontSize: { base: '32px', md: '48px' },
      lineHeight: { base: '30.72px', md: '48px' },
    },
    TextLine1: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      color: '#FFFFFF',
      fontWeight: 400,
      fontSize: { base: '20px' },
      lineHeight: { base: '24px' },
    },
    TextLine2: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      color: '#FFFFFF',
      fontWeight: 400,
      textDecoration: 'none',
      fontSize: { base: '18px', md: '20px' },
      lineHeight: { base: '25.2px', md: '28px' },
    },

    sliderIcon: {
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      zIndex: '10',
      p: '10px',
    },
  };

  const finalObj = merge(styleObj, { ...props });
  return finalObj;
};

const OtherSt = {
  en: commonLangStyle({ lang: 'en' }),
  bn: commonLangStyle({ lang: 'bn' }),
  hi: commonLangStyle({
    lang: 'hi',
  }),
  te: commonLangStyle({ 
    lang: 'te',
    titleSubtext: {
      lineHeight: { base: '46px', md: '84px' },
    },
    additionalTextLine: {
      lineHeight: { base: '42px', md: '48px' },
    },
  }),
  kn: commonLangStyle({ lang: 'kn' }),
  gu: commonLangStyle({ lang: 'gu' }),
  mr: commonLangStyle({ lang: 'mr' }),
  ml: commonLangStyle({ lang: 'ml' }),
  'zh-tw': commonLangStyle({ lang: 'zh-tw' }),
  zh: commonLangStyle({ lang: 'zh' }),
  it: commonLangStyle({ lang: 'it' }),
  fr: commonLangStyle({ lang: 'fr' }),
  de: commonLangStyle({ lang: 'de' }),
  es: commonLangStyle({ lang: 'es' }),
  ru: commonLangStyle({ lang: 'ru' }),
  ta: commonLangStyle({ lang: 'ta' }),
  cn: commonLangStyle({ lang: 'cn' }),
  ar: commonLangStyle({
    lang: 'ar',
  }),
  id: commonLangStyle({ lang: 'id' }),
};
export default OtherSt;
